import React, {useState} from 'react'
import {
    Form,
    Input,
    Select,
    Button,
    Typography,
    message,
    Progress, Card, Divider, notification
} from 'antd'
import * as API_USER from "../../../shared/http/user";
import ValidateUser from "../../utils/ValidateUser";
import Constants from "../../../const/Constants";
import TelegramLoginButton from "../../elements/buttons/TelegramLoginButton";
import GoogleAuthButton from "../../elements/buttons/GoogleAuthButton";
import AppAuthButton from "../../elements/buttons/AppAuthButton";
import {Link} from "react-router-dom";
import {NavigationPages} from "../../../common/navigation/navigation-pages";
import {registration} from "../../../shared/http/user";
import {handleHttpError} from "../../../common/utils/errors";
import {setLoadingRoutine} from "../../../store/global";
import {RegistrationUserFormDto} from "../../../shared/types/api";
import {SuccessRegistrationModal} from "../../modalwindows/SuccessRegistrationModal";

const {Title, Text} = Typography

const RegistrationWizard: React.FC = () => {
    const [current, setCurrent] = useState(0)
    const [loadingRegistration, setLoadingRegistration] = useState<boolean>(false)
    const [form] = Form.useForm()
    const [api, contextHolder] = notification.useNotification();
    const [isVisibleSuccessModal, setIsVisibleSuccessModal] = useState<boolean>(false)
    const [loginStatus, setLoginStatus] = useState<'' | 'validating' | 'error' | 'success'>('')
    const [registeredUserEmail, setRegisteredUserEmail] = useState<string>('')
    const steps = [
        {
            title: 'Придумайте логин',
            content: (
                <Form.Item
                    name="username"
                    label="Придумайте логин"
                    validateStatus={loginStatus}
                    hasFeedback
                    validateFirst
                    rules={[
                        {required: true, message: 'Введите логин'},
                        {
                            pattern: ValidateUser.regExpLogin,
                            message: ValidateUser.errorLogin
                        }
                    ]}
                >
                    <Input size="large" placeholder="your_nickname"/>
                </Form.Item>
            )
        },
        {
            title: 'Создайте пароль',
            content: (
                <Form.Item
                    name="password"
                    label="Создайте пароль"
                    hasFeedback
                    validateFirst
                    rules={[
                        {
                            required: true,
                            message: 'Введите пароль'
                        },
                        {
                            pattern: ValidateUser.regExpPassword,
                            message: 'Пароль должен содержать от 6 до 20 символов'
                        }
                    ]}
                >
                    <Input.Password size="large" placeholder="******"/>
                </Form.Item>
            )
        },
        {
            title: 'Укажите e-mail',
            content: (
                <Form.Item
                    name="email"
                    rules={[
                        {required: true, message: 'Введите e-mail'},
                        {type: 'email', message: 'Неверный формат e-mail'}
                    ]}
                >
                    <Input size="large" placeholder="example@email.com"/>
                </Form.Item>
            )
        }
    ]

    const closeSuccessModal = () => {
        setIsVisibleSuccessModal(false)
    }

    const next = async () => {
        try {
            if (current === 0) {
                await form.validateFields(['username'])

                const login = form.getFieldValue('username')

                setLoginStatus('validating')

                const inUsed = await API_USER.getLoginCoincidence(login)

                if (inUsed) {
                    setLoginStatus('error')
                    form.setFields([
                        {
                            name: 'username',
                            errors: ['Этот логин уже занят']
                        }
                    ])
                    return
                }

                setLoginStatus('success')
            } else {
                const fieldName = steps[current].content.props.name
                if (fieldName) {
                    await form.validateFields([fieldName])
                }
            }

            setCurrent((prev) => prev + 1)
        } catch (err) {
        }
    }

    const prev = () => {
        setCurrent((prev) => prev - 1)
    }

    const onFinish = async () => {
        try {
            const values = await form.validateFields()
            const newUser: RegistrationUserFormDto = {
                referralUserId: undefined,
                login: values.username,
                email: values.email,
                password: values.password,
                notificationFlag: false
            }
            setLoadingRegistration(true)
            API_USER.registration(newUser)
                .then((resp) => {
                    setRegisteredUserEmail(resp.data.email)
                    setIsVisibleSuccessModal(true)
                })
                .catch((e) => {
                    api.error({
                        message: `Ошибка`,
                        description: 'Неизвестная ошибка',
                        placement: 'topRight',
                    });
                })
                .finally(() => {
                    setLoadingRegistration(false)

                })
        } catch (err) {
            console.warn('Ошибки валидации:', err)
        }
    }

    const progressPercent = Math.round(((current + 1) / steps.length) * 100)

    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '100vh',
                background: 'var(--color-bg-hover)'
            }}
        >
            {contextHolder}
            <Card
                style={{
                    maxWidth: 420,
                    width: '100%',
                    borderRadius: 12,
                    boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
                }}
            >
                <Progress
                    percent={progressPercent}
                    showInfo={false}
                    strokeColor="#1890ff"
                    style={{marginBottom: 32, transition: 'all 0.4s ease'}}
                />

                <Title level={3} style={{textAlign: 'center', marginBottom: 24}}>
                    {steps[current].title}
                </Title>

                <Form form={form} layout="vertical" onFinish={onFinish}>
                    {steps.map((step, index) => (
                        <div key={index} style={{display: index === current ? 'block' : 'none'}}>
                            {step.content}
                        </div>
                    ))}

                    <div style={{display: 'flex', justifyContent: 'space-between', marginTop: 32}}>
                        {current > 0 && (
                            <Button onClick={prev} size="large" style={{flex: 1, marginRight: 8}}>
                                Назад
                            </Button>
                        )}
                        {current < steps.length - 1 && (
                            <Button
                                type="primary"
                                onClick={next}
                                size="large"
                                style={{flex: 1}}
                            >
                                Далее
                            </Button>
                        )}
                        {current === steps.length - 1 && (
                            <Button type="primary" htmlType="submit" size="large" style={{flex: 1}}
                                    loading={loadingRegistration}>
                                Зарегистрироваться
                            </Button>
                        )}
                    </div>

                    {current === 0 && (
                        <>
                            <Divider plain style={{margin: '24px 0'}}>или регистрация через</Divider>

                            <div style={{display: 'flex', flexDirection: 'column', gap: 12}}>
                                {window.location.hostname === Constants.DOMAIN && (
                                    <TelegramLoginButton
                                        botName={'GeekenglishBot'}
                                        buttonSize={'medium'}
                                        cornerRadius={undefined}
                                        requestAccess={'write'}
                                        usePic={true}
                                        dataAuthUrl={undefined as any}
                                        lang={'ru'}
                                        widgetVersion={19}
                                        children={undefined}
                                        className={'main-flex-center'}
                                    />
                                )}
                                <GoogleAuthButton/>
                                <AppAuthButton/>
                            </div>

                            <div
                                style={{
                                    marginTop: 20,
                                    fontSize: 14,
                                    lineHeight: 1.6,
                                    color: 'var(--color-text-secondary)',
                                    textAlign: 'center'
                                }}
                            >
                                Продолжая, вы соглашаетесь с нашей {' '}
                                <Link to="/personal-policy">политикой конфиденциальности</Link> и полностью принимаете
                                условия{' '}
                                <Link to="/aferta">Оферты</Link>.
                            </div>

                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    flexDirection: "column",
                                    gap: 8,
                                    marginTop: 24,
                                    fontSize: 14,
                                }}
                            >
                                <Text type="secondary">Уже есть аккаунт?</Text>
                                <Link to={NavigationPages.SIGN_IN}>
                                    <Button type="link" style={{padding: 0}}>Вход</Button>
                                </Link>
                            </div>
                        </>
                    )}
                </Form>
            </Card>
            <SuccessRegistrationModal isVisibleSuccessModal={isVisibleSuccessModal}
                                      closeSuccessModal={closeSuccessModal}
                                      registeredUserEmail={registeredUserEmail}
                                      containerId={'root'}/>
        </div>
    )
}

export default RegistrationWizard
